import { CodeBlockRefractor } from "./extensions/refractor.js"
import { extensionsWithoutRefractor } from "./extensionsWithoutRefractor.js"

type Options = {
  dropcursor: Record<string, any> | false
}
export function extensions(options: Options) {
  return [
    ...extensionsWithoutRefractor(options),
    CodeBlockRefractor.configure({
      HTMLAttributes: {
        spellcheck: false,
      },
    }),
  ]
}
